import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private messageService = inject(MessageService);
  private router = inject(Router);

  showErrorMessage(message: string) {
    return this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 4000,
    });
  }

  showSuccessMessage(message: string) {
    return this.messageService.add({
      severity: 'success',
      summary: 'Conseguido',
      detail: message,
      life: 4000,
    });
  }

  showAlertButtonLink(
    icon: SweetAlertIcon,
    title: string,
    text: string,
    buttonText: string,
    link?: string
  ) {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      confirmButtonText: `${buttonText}`,
    }).then(result => {
      if (result.isConfirmed) {
        link && this.router.navigate([link]);
      }
    });
  }
}
